// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"az_nO","question":"az_oO"};